import { type PortfolioAnalyticsPropertyDto } from '@zg-rentals/ts-customer-analytics-client';
import { DisplayingRegionLevel } from '../types/DisplayingRegionLevel';

export const getRegionIdKeyFromRegionLevel = (
  displayMode: DisplayingRegionLevel,
): keyof PortfolioAnalyticsPropertyDto => {
  switch (displayMode) {
    case DisplayingRegionLevel.COUNTRY:
      return 'stateRegionId';
    case DisplayingRegionLevel.STATE:
      return 'stateRegionId';
    case DisplayingRegionLevel.METRO_AREA:
      return 'metroStatRegionId';
    case DisplayingRegionLevel.CITY:
      return 'cityRegionId';
    default:
      return 'stateRegionId';
  }
};
